import React, { useState } from "react";
import { LightMode, DarkMode } from '@mui/icons-material/';
import useThemeMode from "../../../hooks/useThemeMode";
import Tooltip from '@mui/material/Tooltip';

//BtnChangeModeTheme: Componente que renderiza el botón de cambiar el modo a oscuro o claro.

const BtnChangeModeTheme = () => {

    const [mode, setMode] = useState("dark");
    const [showSunIcon, setShowSunIcon] = useState(true);
    const iconStyle = { color: "#ffffff", marginRight: "10px", width: "35px" };

    const handleChangeMode = () => {
        if (mode === "dark") {
            setShowSunIcon(false);
            setMode("ligth");
        }
        if (mode === "ligth") {
            setShowSunIcon(true);
            setMode("dark");
        }
    }

    useThemeMode({ mode }); //Se ejecuta al renderizar el componente, para cambiar el color según el modo.

    return (
        <>
            <Tooltip title="Modo de visibilidad" >
                <button className="btn-change-mode" onClick={handleChangeMode}>

                    {!showSunIcon ? <LightMode sx={iconStyle} /> : <DarkMode sx={iconStyle} />}
                    {!showSunIcon ?
                        <span className="btn-change-mode__text">Claro </span>
                        : <span className="btn-change-mode__text">Oscuro </span>}
                </button>
            </Tooltip>

        </>
    )
};

export default BtnChangeModeTheme;